import { render, staticRenderFns } from "./FreightManagement.vue?vue&type=template&id=0773e8ce&scoped=true&"
import script from "./FreightManagement.vue?vue&type=script&lang=js&"
export * from "./FreightManagement.vue?vue&type=script&lang=js&"
import style0 from "./FreightManagement.vue?vue&type=style&index=0&id=0773e8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0773e8ce",
  null
  
)

export default component.exports